// extracted by mini-css-extract-plugin
export default {"root":"sidebar_root__mg36u","wrapper":"sidebar_wrapper__RlD3T","notice":"sidebar_notice__JmghW"};